// Polish (Polski)
export default {
  nav: {
    home: 'Strona główna',
    wall: 'Tablica',
    groups: 'Grupy',
    users: 'Użytkownicy',
    profile: 'Mój profil',
    help: 'Pomoc',
    membership: 'Członkostwo',
    logout: 'Wyloguj się',
    login: 'Zaloguj się'
  },
  auth: {
    loginSubtitle: 'Zaloguj się, aby kontynuować',
    email: 'E-mail',
    password: 'Hasło',
    noAccount: 'Nie masz konta?',
    createAccount: 'Utwórz konto',
    loginFailed: 'Logowanie nie powiodło się. Sprawdź e-mail i hasło.',
    alreadyHaveAccount: 'Masz już konto?',
    register: 'Zarejestruj się',
    name: 'Imię',
    confirmPassword: 'Potwierdź hasło',
    registrationSuccess: 'Konto utworzone! Możesz się teraz zalogować.',
    registrationFailed: 'Nie udało się utworzyć konta.'
  },
  home: {
    title: 'Społeczność',
    tagline: 'Spokojne miejsce w internecie – bez reklam.',
    description: 'Dziel się codziennością z rodziną, przyjaciółmi i nowymi znajomymi. Bez szumu, bez śledzenia, bez sprzedaży danych.',
    features: {
      noAds: 'Bez reklam',
      simple: 'Prosty i przejrzysty',
      safe: 'Bezpieczna atmosfera + moderacja'
    },
    cta: {
      openWall: 'Otwórz Tablicę',
      createProfile: 'Utwórz darmowy profil',
      goToWall: 'Przejdź do Tablicy',
      readMore: 'Przeczytaj o idei'
    },
    pricing: 'Strona jest darmowa.',
    pricingDetail: 'Ale my też musimy żyć – prosimy o rozważenie darowizny.'
  },
  wall: {
    title: 'Tablica',
    subtitle: 'Tutaj widzisz posty ze społeczności.',
    writePost: 'NAPISZ NA TABLICY',
    placeholder: 'Napisz swój post tutaj...',
    group: 'Grupa',
    noGroup: 'Brak grupy',
    selectImage: 'Wybierz zdjęcie',
    noFileSelected: 'Nie wybrano pliku.',
    send: 'Wyślij',
    public: 'Publiczny',
    members: 'Członkowie',
    private: 'Prywatny',
    visibility: 'Widoczność'
  },
  groups: {
    title: 'Grupy',
    subtitle: 'Grupy, które mają sens – lokalne, hobby, podróże, spacery – łatwo śledzić.',
    createGroup: 'Utwórz grupę',
    allGroups: 'Wszystkie grupy',
    myGroups: 'Moje grupy',
    searchPlaceholder: 'Szukaj grup...',
    noGroups: 'Nie znaleziono grup',
    noMyGroups: 'Nie jesteś jeszcze członkiem żadnej grupy',
    groupName: 'Nazwa grupy',
    description: 'Opis',
    publicGroup: 'Grupa publiczna (każdy może zobaczyć i dołączyć)',
    private: 'Prywatna',
    createdBy: 'Utworzona przez',
    members: 'członków',
    postsCount: 'postów',
    noDescription: 'Brak opisu',
    join: 'Dołącz',
    leave: 'Opuść',
    open: 'Otwórz',
    leaveConfirm: 'Czy na pewno chcesz opuścić tę grupę?',
    postsTab: 'Posty',
    membersTab: 'Członkowie',
    noPosts: 'Brak postów w tej grupie',
    joinToSee: 'Dołącz do grupy, aby zobaczyć posty',
    about: 'O grupie',
    createdOn: 'Utworzona',
    editGroup: 'Edytuj grupę',
    deleteConfirm: 'Czy na pewno chcesz usunąć tę grupę? Wszystkie posty zostaną usunięte.',
    setMember: 'Ustaw jako członka',
    setModerator: 'Ustaw jako moderatora',
    setAdmin: 'Ustaw jako admina',
    removeMember: 'Usuń z grupy',
    removeMemberConfirm: 'Czy na pewno chcesz usunąć {name} z grupy?',
    changeCover: 'Zmień zdjęcie okładki',
    invalidImageType: 'Nieprawidłowy typ pliku. Wybierz zdjęcie.',
    imageTooLarge: 'Zdjęcie jest za duże. Maksymalnie 5MB.'
  },
  profile: {
    title: 'Mój profil',
    editProfile: 'Edytuj profil',
    myPosts: 'Moje posty',
    myGroups: 'Moje grupy',
    overview: 'Przegląd',
    edit: 'Edytuj',
    settings: 'Ustawienia',
    activity: 'Aktywność',
    bio: 'O mnie',
    location: 'Lokalizacja',
    website: 'Strona internetowa',
    birthday: 'Urodziny',
    interests: 'Zainteresowania',
    joined: 'Dołączył/a',
    posts: 'Posty',
    comments: 'Komentarze',
    reactions: 'Reakcje',
    privacy: 'Prywatność',
    showRealName: 'Pokaż prawdziwe imię publicznie',
    showEmail: 'Pokaż e-mail publicznie',
    emailNotifications: 'Powiadomienia e-mail',
    changePassword: 'Zmień hasło',
    currentPassword: 'Aktualne hasło',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź hasło',
    uploadAvatar: 'Prześlij zdjęcie profilowe',
    changeAvatar: 'Zmień zdjęcie profilowe',
    removeAvatar: 'Usuń zdjęcie profilowe',
    bioPlaceholder: 'Opowiedz o sobie...',
    interestsPlaceholder: 'Czym się interesujesz?',
    saveChanges: 'Zapisz zmiany',
    cancelChanges: 'Anuluj',
    profileUpdated: 'Profil zaktualizowany!',
    passwordChanged: 'Hasło zmienione!',
    avatarUploaded: 'Zdjęcie profilowe przesłane!',
    recentPosts: 'Ostatnie posty',
    recentComments: 'Ostatnie komentarze',
    recentReactions: 'Ostatnie reakcje',
    noPosts: 'Brak postów',
    noComments: 'Brak komentarzy',
    noReactions: 'Brak reakcji',
    downloadData: 'Pobierz moje dane',
    deleteAccount: 'Usuń konto',
    deleteAccountWarning: 'To trwale usunie Twoje konto i wszystkie dane. Tej czynności nie można cofnąć.',
    age: 'lat'
  },
  common: {
    loading: 'Ładowanie...',
    error: 'Wystąpił błąd',
    success: 'Sukces!',
    cancel: 'Anuluj',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    post: 'Wyślij',
    comment: 'Komentarz',
    quote: 'Cytuj',
    reply: 'Odpowiedz',
    confirm: 'Potwierdź',
    ok: 'OK',
    data: 'Dane',
    noComments: 'Brak komentarzy. Bądź pierwszy!',
    writeComment: 'Napisz komentarz...',
    replyToComment: 'Odpowiedz na komentarz...',
    deleteConfirm: 'Usunąć ten post?',
    contentRequired: 'Treść nie może być pusta',
    updateFailed: 'Nie udało się zaktualizować posta',
    deleteFailed: 'Nie udało się usunąć posta',
    commentFailed: 'Nie udało się wysłać komentarza'
  },
  users: {
    searchTitle: 'Znajdź użytkowników',
    searchSubtitle: 'Szukaj użytkowników w społeczności',
    searchPlaceholder: 'Szukaj po nazwie użytkownika, imieniu lub e-mailu...',
    search: 'Szukaj',
    searchHint: 'Wpisz co najmniej 2 znaki, aby wyszukać użytkowników',
    resultsFound: 'Znaleziono {count} użytkownik(ów)',
    noResults: 'Nie znaleziono użytkowników. Spróbuj innego wyszukiwania.'
  },
  validation: {
    required: 'To pole jest wymagane',
    email: 'Wprowadź prawidłowy adres e-mail',
    maxLength: 'Maksymalnie {max} znaków',
    passwordMatch: 'Hasła muszą być takie same'
  }
}
